import React from 'react';
import { Button } from '@gjensidige/core-components/lib/button';
import { Default } from '@gjensidige/core-components/lib/alerts/default';
import { ArrowRight } from '@gjensidige/nci-core-icons/lib/arrow-right';
import { Input } from '@gjensidige/core-components/lib/forms/input';
import { InputGroupSimple } from '@gjensidige/core-components/lib/forms/input-group-simple';
import { Spinner } from '@gjensidige/core-components/lib/spinner';
import { GdprComponentSe } from '@gjensidige/gdpr-component-se';
import { CommonError } from '@gjensidige/se-common-error';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';
import { CallMeFormState } from '../../types';
import './UiCallMe.scss';
import { Link } from '@gjensidige/core-typography';

export interface UiCallMeProps {
  contactFormData: CallMeFormState;
  appText: Record<string, string>;
  customerSelectionOptions: {
    label: string;
    value: string;
  }[];
  events: {
    onFormSubmit: () => void;
    onChangeName: (name: string) => void;
    onChangeNum: (num: string) => void;
    onSelectCustomerRelationShip: (selection: string) => void;
  };
}

export function UiCallMe({
  contactFormData,
  appText,
  events,
  customerSelectionOptions
}: UiCallMeProps) {
  function refreshPage() {
    //@ts-ignore
    window.location.reload(true);
  }

  switch(contactFormData.callMeActionStatus) {
    case 'loading': {
      return (
      <div className="spinner-container">
        <Spinner size={72} />
      </div>
      )
    }
    case 'submittedFailure': {
      return (
      <CommonError
        primaryBtnOnClick={refreshPage}
        headingText={appText[contactFormData.callMeActionStatusMessage]}
        descriptionText={appText['keyFailureDesc']}
        imageSrc={fetchGenericIllustrations(
          'ExclamationErrorModal_NCI',
          IllustrationType.SIMPLE,
          [
            {
              name: 'ExclamationErrorModal_NCI',
              filename: 'ExclamationErrorModal_NCI',
              fileType: 'svg'
            }
          ]
        )}
        primaryButtonLabel={appText['keyErroButtonText']}
      />
      )
    }
    case 'submittedSuccessfully': {
      return (
        <div className="call-me-success-container">
          <Default
          title="Tack!"
          text="Vi kommer att ringa upp dig inom kort. Våra öppettider är måndag till fredag, kl. 8.30-17."
          alertType="success"
          closable={false}
          showIcon={true}
          action={
            <Link
              href="/"
              className="to-start-page-link"
              style={{display: 'flex', alignItems: 'center'}}
            >
              Till startsidan <ArrowRight />
            </Link>}
          />
        </div>
      )
    }
    default: {
      return (
        <div className="call-me-container">
          <div className={'content-form'}>
            <Input
              className="call-me-input"
              inputWrapperClassName="customer-name-input"
              errorText={appText['errorTextAll']}
              id="input-name"
              data-testid="input-name"
              invalid={contactFormData.formErrors.nameInvalid}
              required={true}
              labelText={appText['labelName']}
              name="name-value"
              onBlur={(event) => { events.onChangeName(event.currentTarget.value)}}
              onChange={(event) => { events.onChangeName(event.currentTarget.value)}}
              value={contactFormData.name}
            />
            <Input
              className="call-me-input"
              inputWrapperClassName="phone-number-input"
              errorText={
                contactFormData.formErrors.numValidity === 'EMPTY'
                  ? appText['errorTextAll']
                  : appText['keyInvalidPhone']
              }
              id="input-number"
              data-testid="input-number"
              invalid={contactFormData.formErrors.numValidity !== 'VALID'}
              required={true}
              labelText={appText['labelNumber']}
              name="number-value"
              onBlur={(event) => {
                events.onChangeNum(event.currentTarget.value);
              }}
              onChange={(event) => {
                events.onChangeNum(event.currentTarget.value);
              }}
              value={contactFormData.number}
            />
            <InputGroupSimple
              errorText={appText['errorTextAll']}
              centered={false}
              dividers={false}
              header={appText['labelFormHeader']}
              id="input-group-radio-is-customer"
              data-testid="input-group-radio-is-customer"
              name={'radio-customer'}
              options={customerSelectionOptions}
              onChange={(event) => {
                events.onSelectCustomerRelationShip(event.currentTarget.value);
              }}
              type="radio"
              vertical
              value={contactFormData.isCustomer}
            />
          </div>
          <div className="submit-call-me-container">
            <Button
              data-testid="button-submit"
              className="submit-call-me-button"
              onClick={events.onFormSubmit}
              variant="critical"
              disabled={
                contactFormData.formErrors.nameInvalid ||
                contactFormData.formErrors.numValidity !== 'VALID' ||
                contactFormData.name.length === 0 ||
                contactFormData.number.length === 0 ||
                !contactFormData.isCustomer ||
                contactFormData.isCustomer.length === 0
              }
            >
              {appText['callButton']}
            </Button>
            <div className="gdpr-link">
              <GdprComponentSe />
            </div>
        </div>
      </div>
      )
    }
  }
}

export default UiCallMe;